import 'react-spring-bottom-sheet/dist/style.css';

import { BottomSheet } from 'react-spring-bottom-sheet';
import styled from 'styled-components';

import zIndexLayers from '../../services/ZIndexLayers';

interface StyledBottomSheetProps {
  zIndex?: number;
}

export const StyledBottomSheet = styled(BottomSheet)<StyledBottomSheetProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  [data-rsbs-backdrop] {
    z-index: ${(props) => props.zIndex ?? zIndexLayers.backdrop};
  }
  [data-rsbs-overlay] {
    right: unset;
    left: unset;
    z-index: ${(props) => (props.zIndex ? Number(props.zIndex) + 1 : zIndexLayers.modal)};
    max-height: calc(100dvh - 1.5rem);
    border-radius: 12px 12px 0px 0px;
  }
  [data-rsbs-content] {
    padding: 0 1.25rem 1.25rem 1.25rem;
    overflow: hidden;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    [data-rsbs-overlay] {
      right: 0;
      left: 0;
      max-width: unset;
      width: 100%;
    }
  }
`;
